import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { InvoiceInterface } from '../../store/callrecorder/invoicesSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.invoicePath(value.id)
  };
}

export const invoicesEntity = new schema.Entity(
  'invoices',
  {},
  {
    processStrategy
  }
);

export const invoiceEntity = new schema.Entity(
  'invoice',
  {},
  {
    processStrategy
  }
);

const fetchInvoicesCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      invoices: { [key: string]: InvoiceInterface };
    }
  >(response.data.invoices, [invoicesEntity]);

  return {
    invoices: normalized.entities?.invoices || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { invoice: InvoiceInterface; }
  >(response.data.invoice, invoiceEntity);
  return normalized.entities;
}

export const fetchInvoices = createAsyncThunk(
  `${PREFIX}_invoices/fetchInvoices`,
  async (params: object = {}) => fetchInvoicesCollection('/onesky/invoices', params)
);

export const fetchInvoice = createAsyncThunk(
  `${PREFIX}_invoices/fetchInvoice`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/invoices/${id}`);
    return normalizeInstance(response);
  }
);
